/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppMediaTypeSchema } from "@schemas/message/whatsAppMediaTypeSchema";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";
import { common } from "@schemas/common";

// refer to WhatsAppResponseMessageMediaExport
export const whatsAppResponseMediaMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("media"),
  body: z.string().nullable().optional(),

  // Same as header_media* fields
  media_uri: z.string().nullable().optional(),
  asset_id: common.objectId.nullable().optional(),
  media_type: whatsAppMediaTypeSchema.nullable().optional(),
});
